import WorkerService from "../../WorkerService"

const
    UPDATING_RECORD = "UPDATING_RECORD",
    UPDATING_RECORD_SUCCESS = "UPDATING_RECORD_SUCCESS",
    UPDATING_RECORD_ERROR = "UPDATING_RECORD_ERROR"

const initialState = {
    isUpdating: false,
}

export const state = {...initialState}

export const actions = {

    async changeStatus({commit}, {order, workerStatus, cancelStatus}) {
        try {
            commit(UPDATING_RECORD)
            let response = await WorkerService.changeWorkerStatus(order, workerStatus, cancelStatus)
            commit(UPDATING_RECORD_SUCCESS, response.data)
            return response.data
        } catch (error) {
            commit(UPDATING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    }

}

export const mutations = {

    [UPDATING_RECORD](state) {
        state.isUpdating = true
        state.error = null
    },
    [UPDATING_RECORD_SUCCESS](state) {
        state.isUpdating = false
        state.error = null
    },
    [UPDATING_RECORD_ERROR](state, error) {
        state.isUpdating = false
        state.error = error
    }

}

export const getters = {

    isUpdating(state) {
        return state.isUpdating
    },
    hasError(state) {
        return state.error !== null
    },
    error(state) {
        return state.error
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
